export default {
    REDUCER_KEY: "BROKER",
    ENTITY_NAME: "broker",
    RESOURCE: "brokers",
};
